module.exports = __webpack_public_path__ + "images/7e2020c78c234510d69b0dbeefe36bba.jpg";


//////////////////
// WEBPACK FOOTER
// ../public/images/beer-hover.jpg
// module id = 856
// module chunks = 0